import { DateTime as e } from "luxon";
const s = (r) => {
  try {
    const n = e.now(), o = e.fromISO(r);
    if (!o.isValid)
      throw new Error("Invalid date");
    const t = n.diff(o, ["months", "days", "hours", "minutes"]).toObject();
    return t.months ? o.toLocaleString(e.DATE_SHORT) : t.days ? `${Math.floor(t.days)}d` : t.hours ? `${Math.floor(t.hours)}h` : t.minutes ? `${Math.floor(t.minutes)}m` : o.toLocaleString(e.DATE_SHORT);
  } catch {
    return "";
  }
};
export {
  s as getRecentDonationTime
};
